import { createAction, props, union } from "@ngrx/store";
import { AnalyticsEntry } from "app/api/analytics.api.service";
import { AnalyticsQuery } from "app/main/analytics/analytics.types";
import {
    CreateAnalyticsEntryInput,
    DeleteAnalyticsEntryInput,
    GroupAnalyticsEntryInput,
    UpdateAnalyticsEntryInput,
    UpdateAnalyticsEntrySortInput,
} from "app/api/API.service";

const source = "analytics";
const actions = "api";

export const analyticsRequested = createAction(
    `[${source}][${actions}] Analytics requested`,
    props<{ query: AnalyticsQuery }>()
);
export const analyticsLoaded = createAction(
    `[${source}][${actions}] Analytics loaded`,
    props<{ entries: AnalyticsEntry[] }>()
);
export const analyticsCancelled = createAction(
    `[${source}][${actions}] Analytics cancelled`,
    props<{ errorMessage: string }>()
);
export const analyticsEntryCreateRequested = createAction(
    `[${source}][${actions}] Analytics entry create requested`,
    props<{ input: CreateAnalyticsEntryInput }>()
);
export const analyticsEntryCreated = createAction(
    `[${source}][${actions}] Analytics entry created`,
    props<{ entry: AnalyticsEntry }>()
);
export const analyticsEntryCreateCancelled = createAction(
    `[${source}][${actions}] Analytics entry create cancelled`,
    props<{ errorMessage: string }>()
);
export const analyticsEntryUpdateRequested = createAction(
    `[${source}][${actions}] Analytics entry update requested`,
    props<{ input: UpdateAnalyticsEntryInput }>()
);
export const analyticsEntryUpdated = createAction(
    `[${source}][${actions}] Analytics entry updated`,
    props<{ entry: AnalyticsEntry }>()
);
export const analyticsEntryUpdateCancelled = createAction(
    `[${source}][${actions}] Analytics entry update cancelled`,
    props<{ errorMessage: string }>()
);
export const analyticsEntryDeleteRequested = createAction(
    `[${source}][${actions}] Analytics entry delete requested`,
    props<{ input: DeleteAnalyticsEntryInput }>()
);
export const analyticsEntryDeleted = createAction(
    `[${source}][${actions}] Analytics entry deleted`,
    props<{ entry: AnalyticsEntry }>()
);
export const analyticsEntryDeleteCancelled = createAction(
    `[${source}][${actions}] Analytics entry delete cancelled`,
    props<{ errorMessage: string }>()
);
export const analyticsEntryAddGroupRequested = createAction(
    `[${source}][${actions}] Analytics entry add group requested`,
    props<{ input: GroupAnalyticsEntryInput }>()
);
export const analyticsEntryGroupAdded = createAction(
    `[${source}][${actions}] Analytics entry group added`,
    props<{ entry: AnalyticsEntry }>()
);
export const analyticsEntryAddGroupCancelled = createAction(
    `[${source}][${actions}] Analytics entry add group cancelled`,
    props<{ errorMessage: string }>()
);
export const analyticsEntryRemoveGroupRequested = createAction(
    `[${source}][${actions}] Analytics entry remove group requested`,
    props<{ input: GroupAnalyticsEntryInput }>()
);
export const analyticsEntryGroupRemoved = createAction(
    `[${source}][${actions}] Analytics entry group removed`,
    props<{ entry: AnalyticsEntry }>()
);
export const analyticsEntryRemoveGroupCancelled = createAction(
    `[${source}][${actions}] Analytics entry remove group cancelled`,
    props<{ errorMessage: string }>()
);
export const analyticsSortEntriesRequested = createAction(
    `[${source}][${actions}] Analytics sort entries requested`,
    props<{ query: AnalyticsQuery; input: UpdateAnalyticsEntrySortInput[] }>()
);

const all = union({
    analyticsRequested,
    analyticsLoaded,
    analyticsCancelled,
    analyticsEntryCreateRequested,
    analyticsEntryCreated,
    analyticsEntryCreateCancelled,
    analyticsEntryUpdateRequested,
    analyticsEntryUpdated,
    analyticsEntryUpdateCancelled,
    analyticsEntryDeleteRequested,
    analyticsEntryDeleted,
    analyticsEntryDeleteCancelled,
    analyticsEntryAddGroupRequested,
    analyticsEntryGroupAdded,
    analyticsEntryAddGroupCancelled,
    analyticsEntryRemoveGroupRequested,
    analyticsEntryGroupRemoved,
    analyticsEntryRemoveGroupCancelled,
    analyticsSortEntriesRequested,
});
export type AnalyticsActionsUnion = typeof all;
